import {RootState} from 'redux/rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const profileStatus = createSelector(
  [(state: RootState) => state.profile.isLoading],
  isLoading => isLoading,
);

export const profileSuccess = createSelector(
  [(state: RootState) => state.profile.successProfileState],
  successProfileState => successProfileState,
);

export const profileData = createSelector(
  [(state: RootState) => state.profile.profileData],
  profileData => profileData,
);

export const profileFailure = createSelector(
  [(state: RootState) => state.profile.errorProfileState],
  errorProfileState => errorProfileState,
);
